export const home = {
  hero: {
    title1: '发现最精彩的',
    title2: '韩漫世界',
    subtitle: '海量精品韩漫，免费下拉式阅读，智能加载，流畅舒适',
    cta: '开始探索',
    scrollHint: '向下滚动了解更多',
  },
  categorySection: {
    title: '漫画分类',
    subtitle: '多样化分类，快速找到你喜欢的漫画类型',
    romance: '恋爱',
    fantasy: '奇幻',
    action: '动作',
    thriller: '悬疑',
    comedy: '喜剧',
    drama: '剧情',
    exploreAll: '探索全部分类',
  },
  latestSection: {
    title: '最近更新',
    subtitle: '最新章节实时更新，精彩内容不容错过',
    chapter: '话',
    updateTime: '更新于',
  },
  popularSection: {
    title: '热门推荐',
    subtitle: '读者最爱，高人气韩漫精选',
    tagline: '精选推荐',
    recommendText: '这是一部不可错过的韩漫佳作，画风精美细腻，剧情紧凑引人入胜，每一话都让人期待下一话的到来。',
    author: '编辑部推荐',
    prev: '上一部',
    next: '下一部',
  },
  ctaSection: {
    title: '开启你的韩漫阅读之旅',
    subtitle: '加入数百万读者的行列，享受极致阅读体验',
    button: '立即免费阅读',
  },
};